exports.f={}.propertyIsEnumerable;